"use strict";
define(
'stores/students',[
	"jquery",
	"underscore",
	"stores/store",
	"constants/actiontypes"
],
function ($, _, StoreBase, Constants)
{
	Store.prototype = new StoreBase();
	Store.constructor = Store;

	function Store (params)
	{
		// Call parent constructor
		StoreBase.call(this, params);
		
		// Setup the instance
		this.students = null;

		this.registerDispatchListener(function (action)
		{
			var self = this;

			switch(action.actionType) {
				case Constants.ADD_STUDENTS:
					if(!this.students)
						this.students = {};

					if(Array.isArray(action.data)) {
						_.each(action.data, function(data) {
							self.addStudent(data)
						});
					}
					else {
						this.addStudent(action.data);
					}
					this.event.emit("change");
					break;
				case Constants.UPDATED_STUDENT:
					this.updateStudent(action.data);
					this.event.emit("change");
					break;
			}
		}.bind(this));
	}

	Store.prototype.addStudent = function (student)
	{
		this.students[student.id] = student;
	}

	Store.prototype.updateStudent = function(student)
	{
		this.students[student.id] = student;
	}

	Store.prototype.removeStudent = function(student_guid) {
		delete this.students[student_guid];
	}

	Store.prototype.getAll = function (filterOptions, sortOptions)
	{
		if(!this.students)
			return [];

		var students;
		if(filterOptions) {
			var keywordRegExp = null;
			if(filterOptions.keyword && filterOptions.keyword.trim().length >= 3)
				keywordRegExp = new RegExp(filterOptions.keyword.trim().replace(/ /g, "|"), "i");

			var ConnectToStores = require("shared/connect-to-stores");
			
			// Filtered by class
			if(filterOptions.classId) {
				var section = ConnectToStores.classes.get(filterOptions.classId);

				if(section) {
					students = _.map(section.students, function(id) {
						return this.get(id);
					}.bind(this));
				}
			}

			// Filtered by group
			if(filterOptions.groupId) {
				var group = ConnectToStores.groups.get(filterOptions.groupId);

				if(group) {
					students = _.map(group.students, function(id) {
						return this.get(id);
					}.bind(this));
				}
			}

			students = _.filter(students ? students : this.students, function(student) {
				// Filtered by keyword, but it's not matched with student.first_name or student.last_name
				if(keywordRegExp && !keywordRegExp.test(student.first_name) && !keywordRegExp.test(student.last_name)) {
					return;
				}

				return student;
			});
		}
		else {
			students = _.map(this.students, function(student) {
				return student;
			});
		}

		if(sortOptions) {
			students.sort(function(a, b) {
				var aVal = a[sortOptions.sortColumn];
				var bVal = b[sortOptions.sortColumn];

				var result = aVal.localeCompare(bVal);

				if(sortOptions.sortAsc)
					result *= -1;

				return result;
			});
		}

		return students;
	}

	Store.prototype.getFilteredResults = function ()
	{
		return this.filteredResults;
	}

	Store.prototype.get = function(id) {
		if(this.students) {
			return this.students[id];
		}
		return null;
	}

	Store.prototype.getOrPull = function(id) {
		if(this.students && this.students[id]) {
			return this.students[id];
		}
		// var Actions = require("shared/connect-to-actions");
		// Actions.students.pull(id);
		return null;
	}

	Store.prototype.hasStudent = function (id)
	{
		return (id.toLowerCase() in this.students);
	}

	Store.prototype.getStudent = function (id)
	{
		return this.students[id.toLowerCase()];
	}

	return Store;
});
